import { render, staticRenderFns } from "./ObservationDetails.vue?vue&type=template&id=04366992&scoped=true&"
import script from "./ObservationDetails.vue?vue&type=script&lang=js&"
export * from "./ObservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ObservationDetails.vue?vue&type=style&index=0&id=04366992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04366992",
  null
  
)

export default component.exports